import { render, staticRenderFns } from "./AboutUsContent.vue?vue&type=template&id=77c06531"
import script from "./AboutUsContent.vue?vue&type=script&lang=js"
export * from "./AboutUsContent.vue?vue&type=script&lang=js"
import style0 from "./AboutUsContent.vue?vue&type=style&index=0&id=77c06531&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports